module.exports = __webpack_public_path__ + "img/score_raffle.5b9cef81.png";